import styles from './ActionsContainer.module.css';

export const ActionsContainer = ({ children }) => {
  return <section className={styles.container}>
    {children}
  </section>
};
